module.exports = __webpack_public_path__ + "img/coat_3.98f38879.png";